<div class="modal no-overflow  " [ngClass]="visible ? 'show' : ''">
    <div class="modal no-overflow  " [ngClass]="visible ? 'show' : ''">
        <div class="modal__layer" (click)="handleClose.emit()"></div>
        <div class="modal__box show" id="modal01">
            <div class="modal__box__head">
                ¿Estás seguro que quieres suspender esta licencia?
                <a class="modal__close global-hand" (click)="handleClose.emit()"></a>
            </div>
            <div class="modal__box__body">
                <p class="u-m40">
                    Ingresa un motivo para dar de baja la licencia y esta será suspendida automáticamente, Si no estás seguro presiona “Volver” para revisar la información.
                </p>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form form--required u-mb20">
                            <label for="" class="label">
                                Motivo
                            </label>
                            <textarea placeholder="Ingresa" [formControl]="asFormControl(suspensionForm.controls.reason)" ></textarea>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form form--required u-mb20">
                            <label for="" class="label">
                                Desde
                            </label>
                            <app-calendar
                            [canBeUndefined]="false"
                            [controlForm]="suspensionSinceDate"
                            >

                            </app-calendar>

                            <app-error-message [text]="controlSuspensionRangeStartError"></app-error-message>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form form--required u-mb20">
                            <label for="" class="label">
                                Hasta
                            </label>
                            <app-calendar
                            [canBeUndefined]="true"
                            [controlForm]="suspensionUntilDate"
                            [canBeUndefined]="true"
                            >
                            </app-calendar>
                            <app-error-message [text]="controlSuspensionRangeEndError"></app-error-message>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal__box__footer">
                <div class="row">
                    <div class="col-md-12">
                        <a class="btn btn--link modal__close" (click)="handleClose.emit()">Volver</a>
                        <button type="button" class="btn btn--primary" [disabled]="suspensionForm.valid  ? null : true" (click)="onConfirmSuspension()">Suspender</button>
                    </div>
                </div>
            </div>
        </div>


    </div>



  </div>
